import React from 'react';

import { useSidebarResetCounter } from '@futrli/predict/hooks/useSidebarResetCounter/useSidebarResetCounter';

import { PublishForecastDialog } from './publish-forecast-dialog';

interface PublishForecastDialogContainerProps {
  forecastId?: string;
  isOpen: boolean;
  onClose: () => void;
}

export const PublishForecastDialogContainer = ({
  forecastId,
  isOpen,
  onClose
}: PublishForecastDialogContainerProps) => {
  const { resetKey } = useSidebarResetCounter(isOpen);

  if (forecastId) {
    return <PublishForecastDialog key={resetKey} forecastId={forecastId} isOpen={isOpen} onClose={onClose} />;
  }
  return null;
};
